import { filter, slice } from 'lodash';
import React, { useMemo } from 'react';

import { PageWrapper } from '../styles';

import Card from '../components/card';
import Header from '../components/entries/header';

import AnswerBox from '../components/result/answer_box';
import CardsFadeIn from '../components/result/cards_fade_in';
import Grid from '../components/result/grid';
import Title from '../components/result/title';

import Cup from '../components/vector/cup';

const WinnersPage = ({ userEntries }) => {
  const topScore = useMemo(
    () =>
      Object.keys(userEntries)
        .map(id => userEntries[id])
        .reduce(
          (top, entry) =>
            entry.score > top ? ((top = entry.score), top) : top,
          0
        ),
    [userEntries]
  );

  const winners = slice(filter(userEntries, { score: topScore }), 0, 3);

  return (
    <PageWrapper>
      <Header />

      <Grid key="wrapper-grid" winners>
        <AnswerBox key="answer-box">
          <Title evenMargins>
            <Cup height="1.2em" /> Your Suite Pick{' '}
            {winners.length > 1 ? 'Champions' : 'Champion'}
          </Title>
        </AnswerBox>

        <CardsFadeIn key="cards-fade-in" columns={winners.length}>
          {winners.map(winner => (
            <Card
              key={winner.user.id}
              title="WINNER!"
              user={winner.user}
              points={topScore}
              zoom="125%"
            />
          ))}
        </CardsFadeIn>
      </Grid>
    </PageWrapper>
  );
};

export default WinnersPage;
